import { render, staticRenderFns } from "./TeachPlan.vue?vue&type=template&id=dbd53a7c&scoped=true&"
import script from "./TeachPlan.vue?vue&type=script&lang=js&"
export * from "./TeachPlan.vue?vue&type=script&lang=js&"
import style0 from "./TeachPlan.vue?vue&type=style&index=0&id=dbd53a7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd53a7c",
  null
  
)

export default component.exports